import { CepInput, TextInput } from '@core/components/Inputs';
import cepApi from 'app/services/api/cepApi';
import municipioApi from 'app/services/api/servicoGeral/municipioApi';
import React from 'react';

const InputCep = ({
  id,
  idObject = 'pessoa.endereco',
  endereco = {},
  value,
  readOnly,
  disabled,
  autoFocus,
  handleChange,
  onBlur,
  touched,
  error,
  label = 'CEP',
}) => {
  const onChangeCep = async (event) => {
    const cepValue = event.target.value;

    handleChange(event);

    if (cepValue && cepValue.length >= 8) {
      try {
        let response;
        try {
          response = await cepApi.buscarCep(cepValue);

          if (response.data.erro) {
            response = await cepApi.buscarCepWebmania(cepValue);
          }
        } catch (error) {
          response = await cepApi.buscarCepWebmania(cepValue);
        }

        const { cep, uf, cidade: nomeCidade, bairro, logradouro, ibge } = response.data;

        if (ibge) {
          const municipioResponse = await municipioApi.buscarPorIbge(ibge);

          handleChange({
            target: {
              id: idObject,
              value: {
                ...endereco,
                cep: cep?.replace('-', '') || cepValue,
                uf: { sigla: uf, nome: uf },
                logradouro: logradouro || '',
                bairro: bairro || '',
                cidade: {
                  id: municipioResponse.data.id,
                  nome: nomeCidade || municipioResponse.data.nome,
                  ibge: ibge,
                  codigo: ibge,
                },
              },
            },
          });
        }
      } catch (error) {
        console.error('Falha ao buscar CEP:', error);
      }
    }
  };

  return (
    <TextInput
      readOnly={readOnly}
      disabled={disabled}
      fullWidth
      autoFocus={autoFocus}
      label={label}
      id={id}
      onChange={onChangeCep}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      InputProps={{ inputComponent: CepInput }}
    />
  );
};

export default InputCep;
